module.exports = __webpack_public_path__ + "static/media/brochure-right-img.57c8bcc6.png";